//import React from "react";
import React, { useEffect, useContext } from 'react';
import useForm from 'react-hook-form';
import { useTranslation } from 'react-i18next';

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import TextField from '@material-ui/core/TextField';
import FormControl from "@material-ui/core/FormControl";
import FormHelperText from "@material-ui/core/FormHelperText";
import InputAdornment from '@material-ui/core/InputAdornment';


// @material-ui/icons
import Assignment from "@material-ui/icons/Assignment";
import LoadingIcon from "@material-ui/icons/Cached";

// core components
import GridContainer from "beaktShared/components/Grid/GridContainer.js";
import GridItem from "beaktShared/components/Grid/GridItem.js";
import Button from "beaktShared/components/CustomButtons/Button.js";
import Card from "beaktShared/components/Card/Card.js";
import CardBody from "beaktShared/components/Card/CardBody.js";
import CardIcon from "beaktShared/components/Card/CardIcon.js";
import CardHeader from "beaktShared/components/Card/CardHeader.js";
import Snackbar from "beaktShared/components/Snackbar/Snackbar.js";


// services
import { MaskCPF } from "beaktShared/helpers/masks";
import { SessionContext } from "beaktShared/services/session";
import { UseGetApiSimple, UsePostApi } from "beaktShared/services/crudeApiService";

// styles
import styles from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle";

const useStyles = makeStyles(styles);

export default function GestaoListaNegraForm({ addItem, handleView }) {
    const { t } = useTranslation();
    const classes = useStyles();
    const endPoint = 'listanegra/';
    const session = useContext(SessionContext);
    const { register, handleSubmit, setValue, clearError, errors } = useForm({ mode: "onChange" });

    const [notification, setNotification] = React.useState({
        show: false,
        color: 'info',
        message: ''
    });
    const showNotification = (message, color) => {
        setNotification({
            show: true,
            color: color,
            message: message
        });
        setTimeout(function () {
            setNotification(prev => ({ ...prev, show: false }));
        }, 6000);
    };
    useEffect(() => {

    }, []);

    const [loadingValidateCPF, setloadingValidateCPF] = React.useState(false);

    const [cliente, setcliente] = React.useState();

    const handleCPFChange = e => {
        let cpf = e.target.value;
        if (cpf === "")
            return;
        if (cpf.length < 14)
            return;

        const endPoint = "clientes/clientebyCPFbyEstabelecimento/" + cpf + "/" + session.estabelecimentoId;
        UseGetApiSimple(endPoint, 0).then(result => {
            if (result.status !== 200) {
                showNotification(result.message, 'info');
                setloadingValidateCPF(false);
                setValue("nome", "");
                setValue("email", "");
                setcliente(null);
                return false;
            }
            setcliente(result.data);
            setValue("nome", result.data.nome);
            setValue("email", result.data.email);
            setloadingValidateCPF(false);
        });
    }

    //Salvar ListaNegra
    const [loading, setLoading] = React.useState(false);
    const onSubmit = (data, e) => {
        e.preventDefault();

        if (cliente == null || cliente == "") {
            showNotification(' Cliente inexistente!', 'danger');
            return;
        }

        var listanegra = {
            listaNegraClienteId: 0,
            clienteId: cliente.clienteId,
            usuarioId: session.id,
            bloqueado: true,
            estabelecimentoId: session.estabelecimentoId,
            observacao: data.ObsAcao
        }

        setLoading(true);
        const endPoint = "listanegracliente/";
        UsePostApi(endPoint,listanegra).then(result=>{                   
            if(result.status !== 200)
            {                                     
                showNotification(result.message.message,'danger');
                setLoading(false);  
                return false; 
            } 
            addItem(result.data);
            setLoading(false);  
            handleViewForm();
            return true;   
                            
        }); 
    }
    const handleViewForm = () => {
        handleView(true);
    };

    return (

        <div>
            <Snackbar
                place="tr"
                color={notification.color}
                message={notification.message}
                open={notification.show}
                closeNotification={() => setNotification(prev => ({ ...prev, show: false }))}
                close
            />

            <form onSubmit={handleSubmit(onSubmit)}>
                <GridContainer>
                    <GridItem xs={12}>
                        <Card>
                            <CardHeader color="primary" icon>
                                <CardIcon color="primary">
                                    <Assignment />
                                </CardIcon>
                                <h4 className={classes.cardIconTitle}>{t('sidebar.black_list')} </h4>
                            </CardHeader>
                            <CardBody>
                                <GridContainer>
                                    <GridItem xs={12} sm={12} md={12}>
                                        <div className="subTitulo">
                                            <h6>{t('label.blacklist_customer')} </h6>
                                        </div>
                                    </GridItem>
                                    <GridItem xs={12} sm={6} md={3}>
                                        <FormControl fullWidth className={classes.formControl}>
                                            <TextField
                                                error={errors.cpf ? true : false}
                                                label={t('label.cpf') + " *"}
                                                variant="outlined"
                                                onChange={handleCPFChange}
                                                inputRef={register({ required: false })}
                                                name="cpf"
                                                InputLabelProps={{ shrink: true }}
                                                InputProps={{
                                                    inputComponent: MaskCPF,
                                                    endAdornment: (
                                                        <InputAdornment position="end">
                                                            {loadingValidateCPF && <LoadingIcon className="rotate" />}
                                                        </InputAdornment>
                                                    ),
                                                }}
                                            />
                                            {errors.cpf &&
                                                <FormHelperText className={classes.labelRootError}>
                                                    <span>{errors.cpf.message} </span>
                                                </FormHelperText>}
                                        </FormControl>
                                    </GridItem>
                                    <GridItem xs={12} sm={12} md={6}>
                                        <FormControl fullWidth className={classes.formControl}>
                                            <TextField
                                                fullWidth
                                                label={t('label.name')}
                                                disabled={true}
                                                error={errors.nome ? true : false}
                                                variant="outlined"
                                                defaultValue=""
                                                name="nome"
                                                InputLabelProps={{ shrink: true }}
                                                inputRef={register({ required: true })}

                                            />
                                        </FormControl>
                                    </GridItem>
                                    <GridItem xs={12} sm={6} md={6}>
                                        <FormControl fullWidth className={classes.formControl}>
                                            <TextField
                                                fullWidth
                                                disabled={true}
                                                error={errors.email ? true : false}
                                                label={t('label.email')}
                                                variant="outlined"
                                                defaultValue=""
                                                name="email"
                                                InputLabelProps={{ shrink: true }}
                                                inputRef={register({ required: true })}
                                            />
                                        </FormControl>
                                    </GridItem>
                                    <GridItem xs={12} sm={12} md={12}>
                                        <br></br>

                                        <FormControl fullWidth className={classes.formControl}>
                                            <TextField
                                                label={t('label.obs_action')}
                                                variant="outlined"
                                                inputRef={register}
                                                name="ObsAcao"
                                                defaultValue={""}
                                                InputLabelProps={{ shrink: true }}
                                                multiline
                                                rowsMax="3"
                                                rows="2"
                                                inputProps={{ maxLength: 500 }}
                                            />
                                        </FormControl>
                                    </GridItem>
                                </GridContainer>
                            </CardBody>
                        </Card>
                    </GridItem>
                </GridContainer>
                <GridContainer>
                    <GridItem xs={12} sm={12} md={12} className={classes.textCenter}>
                        <Button onClick={() => handleViewForm()} color="transparent" className={classes.updateProfileButton}>
                            {t('button.cancel')}
                        </Button>
                        <Button type="submit" color="primary" className={classes.updateProfileButton}>
                            {t('button.to_save')}
                            {loading && <div>{t('label.loading') + "..."}</div>}
                        </Button>
                    </GridItem>
                </GridContainer>
            </form>

        </div>
    );
}